var connectError = '@duplexer:connect_error';
var subscriptionFailed = '@duplexer:subscription_failed';
var SOCKET_RECONNECT_TIMEOUT = 5000;
var DuplexerSubscriber = /** @class */ (function () {
    function DuplexerSubscriber(duplexer, appDefId, logger) {
        this.duplexer = duplexer;
        this.appDefId = appDefId;
        this.logger = logger;
        this.activeSubscriptions = [];
        this.connectSocket();
    }
    DuplexerSubscriber.prototype.connectSocket = function () {
        var _this = this;
        this.socket = this.duplexer.connect({ appDefId: this.appDefId });
        this.socket.on(connectError, function (error) {
            _this.logError(connectError, error);
            _this.socket.disconnect();
            _this.clearTimeoutSafe(_this.socketTimer);
            _this.socketTimer = setTimeout(function () { return _this.connectSocket(); }, SOCKET_RECONNECT_TIMEOUT);
        });
        this.connectChannel();
    };
    DuplexerSubscriber.prototype.connectChannel = function () {
        var _this = this;
        this.channel = this.socket.subscribeToUserChannel();
        this.channel.on(subscriptionFailed, function (error) {
            _this.logError(subscriptionFailed, error);
            _this.channel.unsubscribe();
            _this.socket.disconnect();
            _this.clearTimeoutSafe(_this.channelTimer);
            _this.channelTimer = setTimeout(function () {
                _this.connectSocket();
                // Resubscribing to the existing subscriptions
                _this.activeSubscriptions.forEach(function (_a) {
                    var event = _a.event, handler = _a.handler;
                    _this.channel.on(event, handler);
                });
            }, SOCKET_RECONNECT_TIMEOUT);
        });
    };
    DuplexerSubscriber.prototype.subscribe = function (event, handler) {
        this.channel.on(event, handler);
        this.activeSubscriptions.push({ event: event, handler: handler });
    };
    DuplexerSubscriber.prototype.unsubscribe = function () {
        this.clearTimeoutSafe(this.socketTimer);
        this.clearTimeoutSafe(this.channelTimer);
        this.socket.removeAllListeners();
        this.channel.removeAllListeners();
        this.activeSubscriptions = [];
    };
    DuplexerSubscriber.prototype.clearTimeoutSafe = function (timer) {
        if (timer) {
            clearTimeout(timer);
        }
    };
    DuplexerSubscriber.prototype.logError = function (message, error) {
        this.logger.log({
            message: message,
            error: error,
            callParams: { appDefId: this.appDefId },
        });
    };
    return DuplexerSubscriber;
}());
export { DuplexerSubscriber };
//# sourceMappingURL=DuplexerSubscriber.js.map